import { render, staticRenderFns } from "./consult-astrology.vue?vue&type=template&id=3fed5c36&scoped=true"
import script from "./consult-astrology.vue?vue&type=script&lang=js"
export * from "./consult-astrology.vue?vue&type=script&lang=js"
import style0 from "./consult-astrology.vue?vue&type=style&index=0&id=3fed5c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed5c36",
  null
  
)

export default component.exports